import { Box } from '@material-ui/core';
import { Description } from '@material-ui/icons';
import TableBuilder from 'components/Table';
import i18n from 'i18n';
import { TableCellI } from 'interfaces/tableCell';
import { FunctionComponent, useEffect, useState } from 'react';
import { DropResult } from 'react-beautiful-dnd';
import { secondsToDuration } from 'utils/time';
import Search from 'components/Search';

interface StoriesTableI {
  stories: $Lns.Story[];
  tableCells?: TableCellI[];
  storyPool?: $Lns.StoryPool;
  highlightedStories?: $Lns.Story[];
  onClick: (rowItem: { guid: { value: string } }) => void;
  onDragComplete?: (result: DropResult) => void;
}

const StoriesTable: FunctionComponent<StoriesTableI> = ({
  stories,
  highlightedStories,
  storyPool,
  tableCells,
  onDragComplete,
  onClick,
  ...props
}: StoriesTableI) => {
  const [filteredStories, setFilteredStories] = useState(stories);

  useEffect(() => {
    setFilteredStories(stories);
  }, [stories]);

  const isHighlighted = (story: $Lns.Story): boolean => {
    if (!highlightedStories) return false;

    return !!highlightedStories.find(
      currentStory => currentStory.guid === story.guid
    );
  };

  const rows = [
    i18n.t('pages.stories.tableRow.pos'),
    i18n.t('pages.stories.tableRow.img'),
    i18n.t('pages.stories.tableRow.slug'),
    i18n.t('pages.stories.tableRow.title'),
    i18n.t('pages.stories.tableRow.duration'),
    i18n.t('pages.stories.tableRow.plannedDuration')
  ];

  const cells =
    tableCells !== undefined
      ? [...tableCells]
      : filteredStories.map((story, index) => {
          return {
            selected: isHighlighted(story),
            fields: {
              pos: { value: index },
              guid: { value: story.guid, hidden: true },
              img: {
                value: <Description color="primary" />
              },
              slug: { value: story.slug },
              title: { value: story.title },
              duration: { value: secondsToDuration(story.calculatedDuration) },
              plannedDuration: {
                value: secondsToDuration(story.plannedDuration)
              }
            }
          };
        });

  return (
    <Box display="grid" gridGap={10} {...props}>
      <Search
        fields={stories}
        searchKeys={['title', 'notes', 'slug']}
        filterFields={setFilteredStories}
      />

      <TableBuilder
        rows={rows}
        cells={cells}
        onRowClick={onClick}
        isDraggable={!!onDragComplete}
        onDragComplete={onDragComplete}
      />
    </Box>
  );
};

export default StoriesTable;

StoriesTable.defaultProps = {
  highlightedStories: undefined,
  storyPool: undefined,
  onDragComplete: undefined,
  tableCells: undefined
};
